<template>
  <div style="display: contents;">
    <!-- <b-nav-item-dropdown v-if="inMenu">
      <template v-slot:button-content>
        <i class="flag-icon" :class="'flag-icon-' + flagIcon($language.current)"></i> {{ $language.available[$language.current] }}
      </template>
      <b-dropdown-item-button v-for="(item,key) in $language.available" :key="key" @click="changeLanguage(key)">
        <i class="flag-icon" :class="'flag-icon-' + flagIcon(key)"></i> {{ item }}</b-dropdown-item-button>
    </b-nav-item-dropdown> -->
    <b-dropdown right size="sm" variant="primary">
      <template v-slot:button-content>
        <i class="flag-icon" :class="'flag-icon-' + flagIcon($language.current)"></i> {{ $language.available[$language.current] }}
      </template>
      <b-dropdown-item-button v-for="(item,key) in $language.available" :key="key" @click="changeLanguage(key)">
        <i class="flag-icon" :class="'flag-icon-' + flagIcon(key)"></i> {{ item }}</b-dropdown-item-button>
    </b-dropdown>
  </div>
</template>

<script>
import { localize } from 'vee-validate'
import { veeValidateLangMapping } from '@/config/translate'

export default {
  name: 'languages-dropdown',
  props: {
    inMenu: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    changeLanguage: function (lang) {
      localStorage.setItem('language', lang)
      this.$language.current = lang
      localize(veeValidateLangMapping[lang])

      // Refresh is unnecessary on login pages
      location.reload()
    },
    flagIcon: function (lang) {
      // the first 2 letters are the language, but we need the country for the flag
      const cntry = lang.substring(3, 5)
      return cntry.toLowerCase()
    }
  }
}
</script>
